import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
 
const title = "Latest Blog Posts";
 
/* ===== SLUG HELPER ===== */
const slugify = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");
 
const IMAGE_BASE_URL =
  "https://kalakakshaaha.com/uploads/blogs/";
 
const PopularPost = () => {
  const [posts, setPosts] = useState([]);
 
  /* ================= FETCH BLOGS ================= */
  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/blogs")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setPosts(data.blogs.slice(0, 6)); // show 6 popular posts
        }
      })
      .catch((err) => console.error("PopularPost API error", err));
  }, []);
 
  return (
    <div className="widget widget-post">
      <div className="widget-header">
        <h5 className="title">{title}</h5>
      </div>
 
      <ul className="widget-wrapper">
        {posts.map((post) => (
          <li
            className="d-flex flex-wrap justify-content-between"
            key={post.id}
          >
            {/* IMAGE */}
            <div className="post-thumb">
              <Link to={`/blog/${slugify(post.title)}`}>
                <img
                  src={`${IMAGE_BASE_URL}${post.image}`}
                  alt={post.title}
                  onError={(e) =>
                    (e.target.src = "/assets/images/blog/01.jpg")
                  }
                />
              </Link>
            </div>
 
            {/* CONTENT */}
            <div className="post-content">
              <Link to={`/blog/${slugify(post.title)}`}>
                <h6>{post.title}</h6>
              </Link>
              <p>
                {new Date(post.published_date).toDateString()}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
 
export default PopularPost;
 
 